import { useState, useEffect, useRef, useCallback, useMemo } from "react";

import spider from "./img/spider.svg";
import { Button } from "react-bootstrap";

export default function OnlineStatus({ onlineStatus, userObjects, requestActiveUser }) {
   const [showSpider, setShowSpider] = useState(false);
   return (
      <>
         {onlineStatus ? (
            <div className="online-status-border">
               {showSpider && (
                  <div className="spider-frame">
                     <svg
                        className="spider-img"
                        width="210mm"
                        height="297mm"
                        viewBox="0 0 210 297"
                        version="1.1"
                        id="svg1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:svg="http://www.w3.org/2000/svg"
                     >
                        <defs id="defs1" />
                        <g id="layer1">
                           <circle
                              style={{ fill: "#000", strokeWidth: 1 }}
                              id="path1_1"
                              cx="102.37884"
                              cy="218"
                              r="20"
                           />

                           <path
                              className="leftwing"
                              style={{ fill: "#000", stroke: "#000", strokeWidth: 1 }}
                              d="m 88,210 c 0,0 -22.69313,-16.1447 -35.838,-16.48548 -18.38368,-0.4766 -51.24835152,20.42766 -51.24835152,20.42766 0,0 37.09769152,-6.74922 51.96511152,-6.09246 14.86742,0.65676 36.19638,7.52598 36.19638,7.52598 z"
                              id="path5"
                           />

                           <path
                              className="rightwing"
                              style={{ fill: "#000", stroke: "#000", strokeWidth: 1 }}
                              d="m 120,210 c 0,0 22.69313,-16.1447 35.838,-16.48548 18.38368,-0.4766 51.24835,20.42766 51.24835,20.42766 0,0 -37.09769,-6.74922 -51.96511,-6.09246 -14.86742,0.65676 -36.19638,7.52598 -36.19638,7.52598 z"
                              id="path9"
                           />
                           <g className="spider-eyes">
                              <circle
                                 style={{ fill: "#fff", strokeWidth: 1 }}
                                 id="path11"
                                 cx="92.910027"
                                 cy="219.23898"
                                 r="7.8824248"
                              />
                              <circle
                                 style={{ fill: "#000", strokeWidth: 1 }}
                                 id="path12"
                                 cx="94"
                                 cy="220"
                                 r="3.1832869"
                              />
                           </g>

                           <g className="spider-eyes">
                              <circle
                                 style={{ fill: "#fff", strokeWidth: 1 }}
                                 id="path11-8"
                                 cx="110.80116"
                                 cy="219.09816"
                                 r="7.8824248"
                              />
                              <circle
                                 style={{ fill: "#000", strokeWidth: 1 }}
                                 id="path12-2"
                                 cx="112.2"
                                 cy="220"
                                 r="3.1832869"
                              />
                           </g>
                           <path
                              className="beak"
                              style={{ fill: "#ff922c", stroke: "#ff922c", strokeWidth: 0 }}
                              d="m 95.329093,231.51351 5.734087,17.91901 5.73408,-17.91901 z"
                              id="path9"
                           />
                        </g>
                        <text x="19" y="260" fill="red" fontWeight={700} fontSize={10}>
                           Achtung Überspeicherungsgefahr!
                        </text>
                        <text x="19" y="274" fill="black" fontSize={10}>
                           Jemand anderes ist hier noch online.
                        </text>
                     </svg>
                  </div>
               )}
               <div className="online-status-names" onClick={() => setShowSpider(false)}>
                  aktuell online:{" "}
                  {userObjects &&
                     Object.values(onlineStatus).map((userItem) => {
                        return (
                           <span className="mx-1">
                              {userObjects[userItem.userId] && userObjects[userItem.userId].Name}
                           </span>
                        );
                     })}
                  <Button
                     className="mx-3"
                     variant="light"
                     onClick={() => {
                        console.log("zugriff angefragt");

                        requestActiveUser();
                     }}
                  >
                     Zugriff anfragen
                  </Button>
               </div>
               <div className="online-status-frame"></div>
            </div>
         ) : (
            <div className="online-status"></div>
         )}
      </>
   );
}
